import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { SharedErrorHandler } from '@sitemule/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppErrorHandler extends SharedErrorHandler {
  override handleError(error: any) {

    if (environment.production) {
      Sentry.captureException(error.originalError || error);
    }

    super.handleError(error);
    throw error; // This should be removed when SharedErrorHandler is updated
  }
}
